/**
 * w-projectId
 * w-projectId-feature
 * w-projectId-feature-featureId
 *
 *
 * r-projectId
 * r-projectId-feature
 * r-projectId-feature-featureId
 *
 *
 *
 *
 *
 *
 */
export var Feature;
(function (Feature) {
    Feature["SCHEDULES"] = "schedule";
    Feature["CONTRACTS"] = "contracts";
    Feature["RFIS"] = "rfis";
    Feature["SUBMITTALS"] = "submittals";
    Feature["FILES"] = "files";
})(Feature || (Feature = {}));
export default class RoleUtils {
    static PROJECT_DB_NAME = /^p-(\d+|demo)(?:-.*)?$/;
    projectId;
    constructor(projectId) {
        this.projectId = projectId;
    }
    get anyoneReadWrite() {
        return [`p-${this.projectId}-read`, `p-${this.projectId}-basic`]; // Databases such as feed, tags, files that can be written by all users.
    }
    get anyoneReadAdminWrite() {
        return [`p-${this.projectId}-read`, `p-${this.projectId}-basic`, `p-${this.projectId}-write`]; // Databases such as feed, tags, files that can be written by all users.
    }
    get peopleRoles() {
        return [...this.anyoneReadAdminWrite, `p-${this.projectId}-people-write`];
    }
    get featureBaseRoles() {
        return [`p-${this.projectId}-read`, `p-${this.projectId}-write`]; // must not include -basic
    }
    get filesRoles() {
        return [...this.featureBaseRoles, `p-${this.projectId}-files-read`, `p-${this.projectId}-files-write`];
    }
    get scheduleRoles() {
        return [...this.featureBaseRoles, `p-${this.projectId}-schedules-read`, `p-${this.projectId}-schedules-write`];
    }
    get scheduleWorklogsRoles() {
        return [...this.scheduleRoles, `p-${this.projectId}-worklogs-read`, `p-${this.projectId}-worklogs-write`];
    }
    /**
     * With these logs, the admins can't create new types, even a user with schedule write roles cant do it.
     
    get hoursTypesRoles(): string[] {
      return [`p-${this.projectId}-type`, `p-${this.projectId}-type-write`];
    }
      */
    /**
     * with these roles, the project admins and those with schedule permissions can't add logs
    
    get hoursLogRoles(): string[] {
      return [...this.anyoneReadAdminWrite, `p-${this.projectId}-log`, `p-${this.projectId}-log-write`];
    }
       */
    get digestSignerRoles() {
        return [...this.featureBaseRoles, `p-${this.projectId}-digest-write`];
    }
    static isDigestSigner(projectId, roles) {
        return roles.includes(`p-${projectId}-write`) || roles.includes(`p-${projectId}-digest-write`);
    }
    get scheduleFilterRoles() {
        return [`p-${this.projectId}-read`, `p-${this.projectId}-schedules-read`]; // no write restriction on schedule filters
    }
    get rfiRoles() {
        return [...this.featureBaseRoles, `p-${this.projectId}-rfis-read`, `p-${this.projectId}-rfis-write`];
    }
    get submittalRoles() {
        return [...this.featureBaseRoles, `p-${this.projectId}-submittals-read`, `p-${this.projectId}-submittals-write`];
    }
    get contractRoles() {
        return [...this.featureBaseRoles, `p-${this.projectId}-contracts-read`, `p-${this.projectId}-contracts-write`];
    }
    static getBasicRole(projectId) {
        return `p-${projectId}-basic`;
    }
    static getRoleGroups(projectId) {
        return [
            {
                icon: 'business-outline',
                title: 'Project Wide Access',
                roles: [
                    { name: 'Can View Entire Project', role: `p-${projectId}-read` },
                    { name: 'Can make changes anywhere in the project', role: `p-${projectId}-write` },
                ],
            },
            {
                icon: 'people',
                title: 'Manage People',
                roles: [{ name: 'Can invite users to the project and update access', role: `p-${projectId}-people-write` }],
            },
            {
                icon: 'calendar',
                title: 'Schedule',
                roles: [
                    { name: 'Can view the Schedule', role: `p-${projectId}-schedules-read` },
                    { name: 'Can upload and edit schedules', role: `p-${projectId}-schedules-write` },
                ],
            },
            {
                icon: 'document',
                title: 'Files',
                roles: [
                    { name: 'Can view all Files', role: `p-${projectId}-files-read` },
                    { name: 'Can upload Files', role: `p-${projectId}-files-write` },
                ],
            },
            {
                icon: 'help-circle',
                title: 'RFIs',
                roles: [
                    { name: 'Can view RFIs', role: `p-${projectId}-rfis-read` },
                    { name: 'Can create and edit RFIS', role: `p-${projectId}-rfis-write` },
                ],
            },
            {
                icon: 'document-text',
                title: 'Submittals',
                roles: [
                    { name: 'Can view Submittals', role: `p-${projectId}-submittals-read` },
                    { name: 'Can create and edit Submittals', role: `p-${projectId}-submittals-write` },
                ],
            },
            {
                icon: 'document',
                title: 'Contracts',
                roles: [
                    { name: 'Can view Contracts', role: `p-${projectId}-contracts-read` },
                    { name: 'Can create and edit Contracts', role: `p-${projectId}-contracts-write` },
                ],
            },
            /*This should be done under p-projectId-schedules-write
            {
              icon: 'settings',
              title: 'Schedule Settings',
              roles: [
                { name: 'Can view Schedule Settings', role: `p-${projectId}-type-read` },
                { name: 'Can create and edit schedule settings', role: `p-${projectId}-type-write` },
              ],
            }
            This will change massively with budget, and I suspect the role will be p-projectId-budget-write for estimates.
      
            To give write access to log hours against a specific schedule task, we will need a specific db
            e.g p-projectId-worklogs
            
            Access can be given using doc level access,
            e.g p-projectId-worklogs-taskId-write
            ,*/
            {
                icon: 'document-text',
                title: 'Daily Work Logs',
                roles: [
                    { name: 'Can view Estimates and Daily Logs', role: `p-${projectId}-worklogs-read` },
                    { name: 'Can create and edit estimates and daily logs', role: `p-${projectId}-worklogs-write` },
                ],
            },
            {
                icon: 'document-text',
                title: 'Digest Signing',
                roles: [{ name: 'Can sign the daily digest', role: `p-${projectId}-digest-write` }],
            },
        ];
    }
    static getBasicRoles(projectId) {
        return [`p-${projectId}-read`, `p-${projectId}-write`, `p-${projectId}-basic`];
    }
    static canReadWriteBasic(projectId, roles) {
        return this.getBasicRoles(projectId).some((role) => roles.includes(role));
    }
    static canWrite(projectId, feature, featureId, roles) {
        if (projectId && feature && featureId && this.hasFeatureIdWriteRole(projectId, feature, featureId, roles)) {
            return true;
        }
        else if (projectId && feature && this.hasFeatureWriteRole(projectId, feature, roles)) {
            return true;
        }
        else if (projectId && this.hasProjectWriteRole(projectId, roles)) {
            return true;
        }
        else {
            return false;
        }
    }
    static hasProjectWriteRole(projectId, roles) {
        return Array.isArray(roles) && roles.includes(`p-${projectId}-write`);
    }
    static hasProjectReadRole(projectId, roles) {
        return Array.isArray(roles) && roles.includes(`p-${projectId}-read`);
    }
    /** CouchDB proxy JWT roles: `p-{projectId}-read` or project write. */
    static hasProjectReadAccess(database, roles) {
        if (!Array.isArray(roles)) {
            return false;
        }
        const projectId = RoleUtils.getProjectIdFromDatabase(database);
        if (!projectId) {
            return false;
        }
        return this.hasProjectReadRole(projectId, roles) || this.hasProjectWriteRole(projectId, roles);
    }
    /** CouchDB proxy JWT roles: `p-{projectId}-read` or project write. */
    static hasProjectWriteAccess(database, roles) {
        if (!Array.isArray(roles)) {
            return false;
        }
        const projectId = RoleUtils.getProjectIdFromDatabase(database);
        if (!projectId) {
            return false;
        }
        return this.hasProjectWriteRole(projectId, roles);
    }
    static getProjectIdFromDatabase(database) {
        const match = database.match(RoleUtils.PROJECT_DB_NAME);
        return match ? match[1] : null;
    }
    static isValidProjectDatabase(database) {
        return Boolean(database.match(RoleUtils.PROJECT_DB_NAME));
    }
    /** CouchDB database-level read using the full database name (e.g. `p-123-files`). */
    static hasFeatureReadAccess(database, roles) {
        if (!this.isValidProjectDatabase(database) || !Array.isArray(roles)) {
            return false;
        }
        if (this.hasProjectReadAccess(database, roles)) {
            return true;
        }
        return roles.includes(`${database}-read`) || this.hasFeatureWriteAccess(database, roles);
    }
    /** CouchDB database-level write using the full database name (e.g. `p-123-files`). */
    static hasFeatureWriteAccess(database, roles) {
        if (!this.isValidProjectDatabase(database) || !Array.isArray(roles)) {
            return false;
        }
        return roles.includes(`${database}-write`) || this.hasProjectWriteAccess(database, roles);
    }
    /** CouchDB document-level read using database name and document id. */
    static hasDocumentReadAccess(database, docId, roles) {
        if (!this.isValidProjectDatabase(database) || !Array.isArray(roles)) {
            return false;
        }
        if (this.hasFeatureReadAccess(database, roles)) {
            return true;
        }
        return roles.includes(`${database}-${docId}-read`) || this.hasDocumentWriteAccess(database, docId, roles);
    }
    /** CouchDB document-level write using database name and document id. */
    static hasDocumentWriteAccess(database, docId, roles) {
        if (this.hasFeatureWriteAccess(database, roles)) {
            return true;
        }
        return Array.isArray(roles) && roles.includes(`${database}-${docId}-write`);
    }
    /** True when the user has any doc-specific read or write role for the database. */
    static hasSomeDocumentReadAccess(database, roles) {
        if (!Array.isArray(roles)) {
            return false;
        }
        return roles.some((role) => role.startsWith(`${database}-`) && (role.endsWith('-read') || role.endsWith('-write')));
    }
    static hasFeatureOrSomeDocumentReadAccess(database, roles) {
        if (!Array.isArray(roles)) {
            return false;
        }
        return this.hasFeatureReadAccess(database, roles) || this.hasSomeDocumentReadAccess(database, roles);
    }
    /** True when the user has any doc-specific write role for the database. */
    static hasSomeDocumentWriteAccess(database, roles) {
        if (!Array.isArray(roles)) {
            return false;
        }
        return roles.some((role) => role.startsWith(`${database}-`) && role.endsWith('-write'));
    }
    static hasFeatureOrSomeDocumentWriteAccess(database, roles) {
        if (!Array.isArray(roles)) {
            return false;
        }
        return this.hasFeatureWriteAccess(database, roles) || this.hasSomeDocumentWriteAccess(database, roles);
    }
    static hasFeatureWriteRole(projectId, feature, roles) {
        return Array.isArray(roles) && roles.includes(`p-${projectId}-${feature}-write`);
    }
    static hasFeatureIdWriteRole(projectId, feature, featureId, roles) {
        return Array.isArray(roles) && roles.includes(`p-${projectId}-${feature}-${featureId}-write`);
    }
    static hasFeatureReadRole(projectId, feature, roles) {
        return (this.hasFeatureWriteRole(projectId, feature, roles) ||
            (Array.isArray(roles) && roles.includes(`p-${projectId}-${feature}-read`)));
    }
    static hasFeatureIdReadRole(projectId, feature, featureId, roles) {
        return (this.hasFeatureIdWriteRole(projectId, feature, featureId, roles) ||
            (Array.isArray(roles) && roles.includes(`p-${projectId}-${feature}-${featureId}-read`)));
    }
    static canRead(projectId, feature, featureId, roles) {
        if (this.canWrite(projectId, feature, featureId, roles)) {
            return true;
        }
        else if (projectId && feature && featureId && this.hasFeatureIdReadRole(projectId, feature, featureId, roles)) {
            return true;
        }
        else if (projectId && feature && this.hasFeatureReadRole(projectId, feature, roles)) {
            return true;
        }
        else if (projectId && this.hasProjectReadRole(projectId, roles)) {
            return true;
        }
        else {
            return false;
        }
    }
    static hasFilesWriteRole(projectId, roles) {
        if (RoleUtils.hasProjectWriteRole(projectId, roles)) {
            return true;
        }
        // Files can be uploaded from multiple features; allow feature-wide or doc-specific write on any of them.
        const features = [Feature.FILES, Feature.CONTRACTS, Feature.RFIS, Feature.SUBMITTALS, Feature.SCHEDULES];
        return features.some((feature) => this.hasFeatureOrSomeDocumentWriteAccess(`p-${projectId}-${feature}`, roles));
    }
    static getDocumentReadRole(database, docId) {
        return `${database}-${docId}-read`;
    }
    static getDocumentWriteRole(database, docId) {
        return `${database}-${docId}-write`;
    }
    static getFeatureRoles(projectId, feature) {
        return [`p-${projectId}-${feature}-read`, `p-${projectId}-${feature}-write`];
    }
    static getFeatureIdRoles(projectId, feature, featureId) {
        return [`p-${projectId}-${feature}-${featureId}-read`, `p-${projectId}-${feature}-${featureId}-write`];
    }
    /**
     * For certain databases, we inspect each doc to see if the user can read it.
     * This means the proxy downloads the entire database, and then inspects each doc.
     * @param userRoles
     * @param docRoles
     * @returns
     */
    static inspectDocumentReadAccess(userRoles, doc) {
        if (!doc.roles || !Array.isArray(doc.roles) || doc.roles.length === 0)
            return false;
        return doc.roles?.some((userRole) => userRoles.some((docRole) => userRole == docRole)) ?? false;
    }
    static inspectDocumentWriteAccess(userRoles, doc) {
        if (!doc.roles || !Array.isArray(doc.roles) || doc.roles.length === 0)
            return false;
        return doc.roles.some((userRole) => userRoles.some((docRole) => userRole == docRole && docRole.endsWith('-write')));
    }
}
